var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2695_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.95 14.9497C13.5255 16.0355 11.7909 16.6371 9.99998 16.6664C4.16665 16.6664 0.833313 9.99969 0.833313 9.99969C1.86989 8.06794 3.30759 6.3802 5.04998 5.0497M8.24998 3.53303C8.82359 3.39876 9.41087 3.33164 9.99998 3.33303C15.8333 3.33303 19.1666 9.99969 19.1666 9.99969C18.6608 10.946 18.0575 11.837 17.3666 12.658M11.7666 11.7664C11.5378 12.012 11.2618 12.209 10.9551 12.3456C10.6484 12.4823 10.3174 12.5557 9.98172 12.5617C9.64605 12.5676 9.31262 12.5058 9.00132 12.3801C8.69003 12.2544 8.40725 12.0672 8.16985 11.8298C7.93246 11.5924 7.74531 11.3096 7.61957 10.9984C7.49383 10.6871 7.43209 10.3536 7.43801 10.018C7.44393 9.68228 7.5174 9.35123 7.65404 9.04457C7.79068 8.7379 7.98769 8.4619 8.23331 8.23303",
    stroke: "#8D8D8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 0.833008L19.1666 19.1663",
    stroke: "#8D8D8D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2695_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.6f4c14411f2938b413999e0c6cf32fd7.svg";
export { ForwardRef as ReactComponent };